import angular from 'angular';

module.exports = angular.module('market.directives', [
  require('./od-anchor-scroll.js'),
  require('./od-mailcheck.js'),
  require('./od-map.js'),
  require('./od-scroll-enter.js'),
  require('./od-splash-map.js'),
  require('./side-scroll-hint.js'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/directives/index.js
 **/